module.exports = __webpack_public_path__ + "img/camiseta.544c1cea.jpg";